import { apiPaths, getApiPath, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET
export const GET_GLOBAL_LOCATIONS_SUCCESS = 'GET_GLOBAL_LOCATIONS_SUCCESS'
export const GET_GLOBAL_LOCATIONS_FAILURE = 'GET_GLOBAL_LOCATIONS_FAILURE'

// -- CREATE
export const CREATE_GLOBAL_LOCATION_SUCCESS = 'CREATE_GLOBAL_LOCATION_SUCCESS'
export const CREATE_GLOBAL_LOCATION_FAILURE = 'CREATE_GLOBAL_LOCATION_FAILURE'

// -- UPDATE
export const UPDATE_GLOBAL_LOCATION_SUCCESS = 'UPDATE_GLOBAL_LOCATION_SUCCESS'
export const UPDATE_GLOBAL_LOCATION_FAILURE = 'UPDATE_GLOBAL_LOCATION_FAILURE'

// -- DELETE
export const DELETE_GLOBAL_LOCATION_SUCCESS = 'DELETE_GLOBAL_LOCATION_SUCCESS'
export const DELETE_GLOBAL_LOCATION_FAILURE = 'DELETE_GLOBAL_LOCATION_FAILURE'

// -- SELECT
export const SELECT_GLOBAL_LOCATIONS = 'SELECT_GLOBAL_LOCATIONS'

// -----------------------------------------------------------------------------

/**
 * GET the list of all global locations attributes.
 *
 * @returns {Promise<array<object>>}
 */
export const getGlobalLocations = () => async (dispatch) => {
  const path = apiPaths.GLOBAL_LOCATION_LIST
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalLocationsActions.getGlobalLocations()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_GLOBAL_LOCATIONS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_GLOBAL_LOCATIONS_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a new global location attribute.
 *
 * @param {object} newLocation New global location attribute object to create
 * @returns {Promise<object>}
 */
export const createGlobalLocation = (newLocation) => async (dispatch) => {
  const path = apiPaths.GLOBAL_LOCATION_CREATE
  const api = new Api(path)
  const result = await api.create(newLocation)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalLocationsActions.createGlobalLocation()', {
    path,
    newLocation,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_GLOBAL_LOCATION_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_GLOBAL_LOCATION_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific global location attribute based on its location ID
 *
 * @param {object} newLocation Object to set instead of the previous one.
 * @param {uui} lid Location ID to update
 * @returns {Promise<object>}
 */
export const updateGlobalLocation = (newLocation, lid) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_LOCATION_UPDATE, { lid })
  const api = new Api(path)
  const result = await api.update(newLocation)
  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalLocationsActions.updateGlobalLocation()', {
    path,
    newLocation,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_GLOBAL_LOCATION_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_GLOBAL_LOCATION_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific global location attribute based on its UUID.
 *
 * @param {uuid} lid Global location UUID to delete.
 * @returns {Promise<string>}
 */
export const deleteGlobalLocation = (lid) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_LOCATION_DELETE, { lid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalLocationsActions.deleteGlobalLocation()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_GLOBAL_LOCATION_SUCCESS,
      data: lid
    })
  }
  return dispatch({
    type: DELETE_GLOBAL_LOCATION_FAILURE,
    data: result.data
  })
}

/**
 * SELECT a list of global location attribute UUID.
 *
 * @param {array<uuid>} data Array of location ID to select.
 * @returns {Promise<array<object>>}
 */
export const selectListGlobalLocations = (data) => async (dispatch) => {
  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalLocationsActions.selectListGlobalLocations()', { data })
  return dispatch({
    type: SELECT_GLOBAL_LOCATIONS,
    data
  })
}
